import { render } from "./caseid-start.vue?vue&type=template&id=0d199b55"
import script from "./caseid-start.vue?vue&type=script&lang=js"
export * from "./caseid-start.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__